module.exports = __webpack_public_path__ + "img/icon-piggybank.2d988713.svg";